export default class Header {
    static isMobileVariantMenu() {
        const bsLevel = getComputedStyle(document.documentElement).getPropertyValue('--intas-break-point-menu-hover');
        const breakpointXxl = getComputedStyle(document.documentElement).getPropertyValue('--bs-breakpoint-' + bsLevel);
        return !window.matchMedia(`(min-width: ${breakpointXxl})`).matches;
    }
    static isMobileVariantHeader() {
        const bsLevel = getComputedStyle(document.documentElement).getPropertyValue('--intas-break-point-header');
        const breakpointXxl = getComputedStyle(document.documentElement).getPropertyValue('--bs-breakpoint-' + bsLevel);
        return !window.matchMedia(`(min-width: ${breakpointXxl})`).matches;
    }
}
